import { render } from "./KeyInfoView.vue?vue&type=template&id=4b2b5bcc&scoped=true"
import script from "./KeyInfoView.vue?vue&type=script&lang=js"
export * from "./KeyInfoView.vue?vue&type=script&lang=js"

import "./KeyInfoView.vue?vue&type=style&index=0&id=4b2b5bcc&scoped=true&lang=css"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2b5bcc"]])

export default __exports__